import { type Action, createGeneralActionsByTransfers } from '@0xtorch/core'
import type { SplTokenInfo } from '../splTokenDatasource'
import { createSolanaActionSource } from '../utils'
import { generateFail } from './generator/fail'
import { generateTransfer } from './generator/transfer'
import { generateTxFee } from './generator/txFee'
import type { GeneratorParameters } from './types'

export const generateNormalActions = async (
  parameters: GeneratorParameters,
): Promise<readonly Action[]> => {
  const {
    transaction,
    tokenTransfers,
    splTokenDatasource,
    // jsonDatasource,
    accountIds,
  } = parameters
  const source = createSolanaActionSource({
    signature: transaction.transaction.signatures[0],
  })
  const accountIdSet = new Set(accountIds)
  const actions: Action[] = []

  // [every]
  // tx fee
  actions.push(...(generateTxFee({ ...parameters, source }) ?? []))

  // [some]
  // fail
  const failActions = generateFail({ ...parameters, source })
  if (failActions !== undefined) {
    actions.push(...failActions)
    return actions
  }

  // splToken list を事前にまとめて取得
  const mut_splTokens: SplTokenInfo[] = []
  const mintAddressSet = new Set(
    tokenTransfers
      .map((transfer) => (transfer.type === 'spl' ? transfer.token : undefined))
      .filter((address): address is string => address !== undefined),
  )
  for (const mintAddress of mintAddressSet) {
    const splToken = await splTokenDatasource.getTokenByMintAccount(mintAddress)
    if (splToken !== undefined) {
      mut_splTokens.push(splToken)
    }
  }
  const splTokens = mut_splTokens

  // TODO 一時的にコメントアウト
  // // json
  // // datasource から programId 毎に JSON 取得して、JSON 毎に generate 実行
  // const programIds = [
  //   ...new Set(
  //     transaction.transaction.message.instructions.map(
  //       ({ programId }) => programId,
  //     ),
  //   ),
  // ]
  // const jsonDatasourceResponses = await Promise.all(
  //   programIds.map((programId) => jsonDatasource.get(programId)),
  // )
  // const analyzerJsons = jsonDatasourceResponses.flat()
  // for (const json of analyzerJsons) {
  //   const actions = generateByJson({
  //     ...parameters,
  //     splTokens,
  //     json,
  //   })
  //   if (actions !== undefined) {
  //     mut_actions.push(...actions)
  //     mut_accountActions.push(
  //       ...actions.flatMap((action) =>
  //         parseNormalActionToAccountActions({
  //           action,
  //           accountIds: accountIdSet,
  //           source,
  //         }),
  //       ),
  //     )
  //     return {
  //       actions: mut_actions,
  //       accountActions: mut_accountActions,
  //     }
  //   }
  // }

  // transfer (general)
  const transfers = generateTransfer({
    ...parameters,
    splTokens,
  })
  if (transfers !== undefined) {
    actions.push(
      ...createGeneralActionsByTransfers({
        transfers,
        accountIds: accountIdSet,
        source,
        timestamp: transaction.blockTime * 1000,
      }),
    )
    return actions
  }

  return actions
}
